import PropTypes from 'prop-types';


export const AccountValuesItemPropType = PropTypes.shape({
  date: PropTypes.string,
  marketValue: PropTypes.string,
});


export const AccountValuesPropType = PropTypes.arrayOf(AccountValuesItemPropType);



// WEBPACK FOOTER //
// ./src/components/Portfolio/PropTypes.js